export default {"src":"/_next/static/media/G_GreenLoader.9bc6a42e.svg","height":100,"width":101,"blurWidth":0,"blurHeight":0};